/**
 * Encapsulates a redirect to the given route.
 */
"use strict";

function Redirect(to, params, query) {
  this.to = to;
  this.params = params;
  this.query = query;
}

module.exports = Redirect;


/*****************
 ** WEBPACK FOOTER
 ** /~/react-router/lib/Redirect.js
 ** module id = 537
 ** module chunks = 9
 **/